import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { RequestInboxApi } from "../../../shared/nestjs/gd-all-in-one/services/request-inbox.api";
import { SFAttCorrectionRequestApi, SFRequestInboxApi, WorkflowApi } from "../../../shared/sdk/services/custom";
import { map } from "rxjs/operators";
import { Storage } from "@ionic/storage";
import { WorkFlowApiProvider } from "../../../shared/nestjs/workflow/workflow-api";
import { GDAttendanceCorrectionApiProvider } from "../../../shared/nestjs/attendance/gd-attendance-correction-api";
import { SfRequestInboxNestApi } from "../../../shared/nestjs/gd-only/services/sf-request-inbox.api";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";

@Injectable()
export class AttendanceCorrectionBloc {
  constructor(
    private nestApiProvider: NestApiProvider,
    private requestInboxApi: RequestInboxApi,
    public sFRequestInboxApi: SFRequestInboxApi,
    public nestResponsesProvider: NestResponsesProvider,
    public sfRequestInboxNestApi: SfRequestInboxNestApi,
    private storage: Storage,
    private sFAttCorrectionRequestApi: SFAttCorrectionRequestApi,
    private workFlowApiProvider: WorkFlowApiProvider,
    private workflowApi: WorkflowApi,
    private gDAttendanceCorrectionApiProvider: GDAttendanceCorrectionApiProvider,
  ) {
  }

  approveSF6(payload): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.requestInboxApi.approve({
            action: payload.hdnAction,
            notes: payload.txtNotes,
            reqNo: payload.hdnRequest.req_no,
            requestfor: payload.hdnRequest.emp_id,
            formData: payload.formData,
          });
        } else {
          return this.sFRequestInboxApi.approveSF6(payload).pipe(map(response => {
            return {
              data: response,
              message: response.hasil.result,
            }
          }));
        }
      })
  }

  showButton(requestNo: string): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.workFlowApiProvider.showButton(requestNo).pipe(map(result => result.data));
        } else {
          return this.workflowApi.showButton(requestNo);
        }
      })
  }

  async getSFGoAuth(): Promise<any> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }

  getRequest(payload): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.gDAttendanceCorrectionApiProvider.getRequest(payload.requestno).pipe(map(result => {
            result.data.forEach(el => {
              el.teomemppersonals = el.teomemppersonal;
            });
            return result.data;
          }));
        } else {
          return this.sFAttCorrectionRequestApi.getRequest(payload);
        }
      })
  }

  getRequestDetail(payload): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.gDAttendanceCorrectionApiProvider.getRequestDetail(payload.requestno, payload.companyId).pipe(map(result => [result.data]));
        } else {
          return this.sFAttCorrectionRequestApi.getRequestDetail(payload);
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/attendance-correction/attendance-correction.bloc.ts